import { Chip } from "@assetwatch/ui";

const priorityPresentation = {
  HIGH: { label: "High", tone: "negative" },
  MEDIUM: { label: "Medium", tone: "warning" },
  LOW: { label: "Low", tone: "neutral" },
} as const;

/**
 * Icon plus label priority marker shared by the Work Request and Work Order
 * cards. Takes the API priority code; NONE and unknown codes render nothing.
 */
export function PriorityIndicator({ priority }: { priority: string }) {
  const presentation =
    priorityPresentation[priority as keyof typeof priorityPresentation];
  if (!presentation) return null;

  return (
    <Chip
      data-slot="priority-indicator"
      icon="priority"
      label={presentation.label}
      tone={presentation.tone}
    />
  );
}
